import React from "react";
import Dropdown from "components/atoms/Dropdown/Dropdown";

interface HandlingUnitFieldProps {
  options: any[];
}

function HandlingUnitField({ options }: HandlingUnitFieldProps) {
  return (
    <div className="dropdown-div packing-list-add-item-input-large" style={{ marginTop: 23 }}>
      <Dropdown
        useHookForm
        name="handling_unit"
        className="schedule-dropdown"
        defaultValue={options?.[0]?.value || ""}
        options={options}
      />
    </div>
  );
}

export default HandlingUnitField;
